import CurrencySelector from '@/app/components/CurrencySelector'
import LanguageAndCurrencySelect from '@/app/components/LanguageAndCurrencyMobile'
import classNames from 'classnames'
import { pick } from 'lodash'
import { NextIntlClientProvider, useMessages } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

interface LogoWithBlogBadgeProps {
	isDesktop?: boolean
	lang: string
}

const LogoWithBlogBadge: FC<LogoWithBlogBadgeProps> = ({
	isDesktop = false,
	lang,
}) => (
	<div className="flex items-center gap-2">
		<Link href={`/${lang}`} aria-label="Main Logo Link">
			<Image
				src="/images/logo.v2.svg"
				width={isDesktop ? 81 : 61}
				height={isDesktop ? 44 : 31}
				alt="BestRentalPrices Logo"
			/>
		</Link>
		<div className={`${isDesktop ? 'h-[38px]' : 'h-[25px]'} w-px bg-main-950`} />
		<Link
			href={`/${lang}/blog`}
			className="text-main-950 font-normal text-sm leading-5 hover:underline"
		>
			BLOG
		</Link>
	</div>
)

export interface Props {
	lang: string
	isMain?: boolean
	isSticky?: boolean
	blogPage?: boolean
	children?: {
		middle?: React.ReactNode
		bottom?: React.ReactNode
	}
}

const Top: FC<Props> = (props) => {
	const { lang, isMain = false, children, isSticky, blogPage } = props
	const messages = pick(useMessages(), ['Keywords', 'Header'])

	return (
		<div
			className={classNames('max-md:bg-white container', {
				'py-3.5 md:py-6 max-lg:rounded-4xl max-w-full w-full 2xl:px-8': !isMain,
				'max-lg:py-5 md:max-lg:px-8': isMain,
			})}
		>
			<div className={classNames('flex justify-between items-center h-[52px]',
				{
					'max-md:h-10': isMain
				})}>
				{blogPage ? (
					<div className="md:hidden">
						<LogoWithBlogBadge lang={lang} />
					</div>
				) : (
					<Link
						href={`/${lang}`}
						aria-label="Main Logo Link"
						className={'md:hidden'}
					>
						{isMain ? (
							<Image
								src="/images/logo.v2.svg"
								width={73}
								height={28}
								alt="BestRentalPrices Logo"
							/>
						) : (
							<Image
								src={'/images/logo-colored.png'}
								width={106}
								height={52}
								alt="BestRentalPrices Logo"
								unoptimized
							/>
						)}
					</Link>
				)}
				<div className="hidden md:block h-full">
					{blogPage ? (
						<LogoWithBlogBadge isDesktop lang={lang} />
					) : (
						<Link
							href={`/${lang}`}
							aria-label="Main Logo Link"
							className="inline-block h-full"
						>
							{isMain ? (
								<Image
									src={'/images/logo.png'}
									width={106}
									height={52}
									alt="BestRentalPrices Logo"
									unoptimized
								/>
							) : (
								<Image
									src={'/images/logo-colored.png'}
									width={106}
									height={52}
									alt="BestRentalPrices Logo"
									unoptimized
								/>
							)}
						</Link>
					)}
				</div>
				{children?.middle}
				<NextIntlClientProvider locale={'en'} messages={messages}>
					<div className="md:hidden flex items-center">
						<LanguageAndCurrencySelect />
					</div>
					<div className="hidden md:flex justify-end">
						{/* <LanguageCurrencySelector
								isMainPage={isMain}
								isSticky={isSticky as boolean}
							/> */}
						<CurrencySelector
							isMainPage={isMain}
							isSticky={isSticky as boolean}
						/>
					</div>
				</NextIntlClientProvider>
			</div>
			{children?.bottom}
		</div>
	)
}

export default Top
